import { RootState } from "@/app/stores"
import { createSelector } from "@reduxjs/toolkit"

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.bonuses
)

export const selectBonuses = createSelector(
    baseSelector,
    (state) => state.bonuses
)

export const selectBonusesLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectBonusesError = createSelector(
    baseSelector,
    (state) => state.error
)

// TODO fetch available bonuses from server
export const selectAvailableBonuses = createSelector(
    (state: RootState) => state,
    (state) => {
        const available = state.community.community.bonuses
        const bonuses = state.bonuses.bonuses
        return available.length ? bonuses.filter(bonus => available.includes(bonus.id)) : bonuses
    }
)